import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick", "onKeydown"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "method-description text-left" }
const _hoisted_6 = { class: "text-body-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    ref: "dialog",
    class: "new-payout-method-dialog",
    dismissible: "",
    size: "medium",
    title: _ctx.$gettext('Set up a Payout Method')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.paymentMethods.length)
          ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" No new payout methods to add, please check back later! ", -1)
            ]))])), [
              [_directive_translate]
            ])
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.paymentMethods, (method) => {
              return (_openBlock(), _createElementBlock("div", {
                key: method.title,
                class: "payout-method-option items-center",
                tabindex: "0",
                onClick: ($event: any) => (_ctx.$emit(method.eventName)),
                onKeydown: _withKeys(($event: any) => (_ctx.$emit(method.eventName)), ["enter"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(`method-image ${method.type}`)
                }, [
                  _createElementVNode("img", {
                    src: String(method.imgSrc),
                    alt: method.imgAltText
                  }, null, 8, _hoisted_4)
                ], 2),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h4", null, _toDisplayString(method.title), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(method.description), 1)
                ])
              ], 40, _hoisted_3))
            }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}